module.exports = __webpack_public_path__ + "media/icons/government-gray-920446e0.png";